import { Loader } from "@delibrandev/utils";
import { useSelector } from "react-redux";

export const LoaderComponent = () => {
  const loading = useSelector((state) => state.aplicationConfig.userConfig.loading);
  return <Loader state={loading} />;
};
